import {
  Component, Input, Output, EventEmitter, signal, computed,
  HostListener, ElementRef, inject, OnChanges, SimpleChanges,
} from '@angular/core';

export interface ClubOption {
  club_id: number;
  club_name: string;
  club_short_code?: string;
  club_code?: string;
  club_logo_url?: string | null;
}

@Component({
  selector: 'app-club-select',
  standalone: false,
  templateUrl: './club-select.component.html',
})
export class ClubSelectComponent implements OnChanges {
  private el = inject(ElementRef);

  @Input() clubs: ClubOption[] = [];
  @Input() value: number = 0;
  @Output() valueChange = new EventEmitter<number>();

  open = signal(false);
  search = signal('');
  _value = signal<number>(0);
  _clubs = signal<ClubOption[]>([]);

  selected = computed<ClubOption | null>(() =>
    this._value() ? (this._clubs().find(c => c.club_id === this._value()) ?? null) : null
  );

  filtered = computed(() => {
    const q = this.search().toLowerCase();
    return q
      ? this._clubs().filter(c =>
          c.club_name.toLowerCase().includes(q) ||
          (c.club_short_code || '').toLowerCase().includes(q) ||
          (c.club_code || '').toLowerCase().includes(q)
        )
      : this._clubs();
  });

  ngOnChanges(_: SimpleChanges): void {
    this._value.set(this.value);
    this._clubs.set(this.clubs);
  }

  toggle(): void { this.open.update(v => !v); if (this.open()) this.search.set(''); }

  select(clubId: number): void {
    this.valueChange.emit(clubId);
    this.open.set(false);
    this.search.set('');
  }

  initials(c: ClubOption): string {
    return (c.club_short_code || c.club_code || c.club_name || '?').charAt(0).toUpperCase();
  }

  label(c: ClubOption): string {
    return c.club_short_code || c.club_code || c.club_name;
  }

  @HostListener('document:click', ['$event'])
  onDocClick(e: MouseEvent): void {
    if (!this.el.nativeElement.contains(e.target)) this.open.set(false);
  }
}
